import { GraphQlLiteral } from "@contember/client";
import { BindingError } from "../../BindingError.js";
const unwrapGraphqlLiteral = (value) => {
  if (value instanceof GraphQlLiteral) {
    return value.value;
  }
  return value;
};
const evaluateCondition = (value, condition) => {
  const handlers = {
    and: (expr) => expr.every((it) => evaluateCondition(value, it)),
    or: (expr) => expr.some((it) => evaluateCondition(value, it)),
    not: (expr) => !evaluateCondition(value, expr),
    eq: (expr) => value === unwrapGraphqlLiteral(expr),
    notEq: (expr) => value !== unwrapGraphqlLiteral(expr),
    isNull: (expr) => value === null === expr,
    in: (expr) => expr.map(unwrapGraphqlLiteral).includes(value),
    notIn: (expr) => !expr.map(unwrapGraphqlLiteral).includes(value),
    lt: (expr) => value !== null && value < unwrapGraphqlLiteral(expr),
    lte: (expr) => value !== null && value <= unwrapGraphqlLiteral(expr),
    gt: (expr) => value !== null && value > unwrapGraphqlLiteral(expr),
    gte: (expr) => value !== null && value >= unwrapGraphqlLiteral(expr),
    contains: (expr) => typeof value === "string" && value.includes(unwrapGraphqlLiteral(expr)),
    startsWith: (expr) => typeof value === "string" && value.startsWith(unwrapGraphqlLiteral(expr)),
    endsWith: (expr) => typeof value === "string" && value.endsWith(unwrapGraphqlLiteral(expr)),
    containsCI: (expr) => typeof value === "string" && value.toLowerCase().includes(unwrapGraphqlLiteral(expr).toLowerCase()),
    startsWithCI: (expr) => typeof value === "string" && value.toLowerCase().startsWith(unwrapGraphqlLiteral(expr).toLowerCase()),
    endsWithCI: (expr) => typeof value === "string" && value.toLowerCase().endsWith(unwrapGraphqlLiteral(expr).toLowerCase()),
    never: () => false,
    always: () => true,
    // deprecated
    null: (expr) => value === null === expr
  };
  return Object.entries(condition).every(([operator, argument]) => {
    if (value === void 0) {
      return true;
    }
    const handlerKey = operator;
    const handler = handlers[handlerKey];
    if (!handler) {
      throw new BindingError();
    }
    return handler(argument);
  });
};
export {
  evaluateCondition
};
//# sourceMappingURL=evaluateCondition.js.map
